var visualizer = function() {
    var WindowRef;
    var childWindow = null;
    var pageWheelModels = {};
    var viewModel = {
        ready: false,
        collapsed: false,
        rotation: 'side',
        thumbClickable: true,
        vehicle: {
            selected: false,
            description: 'Select a vehicle',
            model: null,
            tireOption: null,
            paintSchemes: [],
            selectedScheme: null,
            thumbUrl: null,
            suspension: {
                ranges: {
                    min: -4,
                    max: 4
                },
                locked: true,
                front: 0,
                rear: 0
            }
        },
        wheel: {
            productId: undefined,
            detailsUrl: null,
            selected: false,
            description: 'No wheel selected',
            model: null,
            selectedPartNumber: null,
            selectedFitmentID: null,
            selectedDiameter: null,
            diameters: [],
            wheelImage: null,
            boltPattern: null
        },
        expand: expandPopupModal,
        thumbnailHandler: thumbnailHandler,
        resetVehicleCache: resetVehicleCache,
        openInExternalWindow: openInExternalWindow,
        vehicleCanRotate: vehicleCanRotate,
        getBestRotation: getBestRotation,
        getCachedJsonItem: getCachedJsonItem,
        isWheelRenderable: isWheelRenderable
    };

    var rotationOptions = {
        "side": "side",
        "angle": "angle"
    }

    var visualizerStorageKeys = {
        "viewModel" : "visualizerViewModel",
        "vehicle": "cached-vehicle",
        "wheel": "cached-wheel-visualizer",
        "wheelDiameter": "cached-wheel-diameter",
        "vehicleProfile": "cached-vehicle-profile",
        "suspension": "cached-suspension",
        "paintScheme": "cached-paint-scheme",
        "rotation": "cached-rotation"
    }

    initialize(viewModel);
    //If updating from cache, don't recache.
    var updatingFromCache = false;
    return {
        updateViewModel: function(vm) {
            updatingFromCache = true;

            viewModel.vehicle.selectedScheme = vm.hasOwnProperty('Scheme') ? vm.Scheme : viewModel.vehicle.selectedScheme;
            viewModel.vehicle.suspension.locked = vm.hasOwnProperty('locked') ? vm.locked : viewModel.vehicle.suspension.locked;
            viewModel.vehicle.suspension.rear = vm.hasOwnProperty('rear') ? vm.rear : viewModel.vehicle.suspension.rear;
            viewModel.vehicle.suspension.front = vm.hasOwnProperty('front') ? vm.front : viewModel.vehicle.suspension.front;
            viewModel.wheel = vm.hasOwnProperty('wheel') ? vm.wheel : viewModel.wheel;
            viewModel.vehicle = vm.hasOwnProperty('vehicle') ? vm.vehicle : viewModel.vehicle;
            viewModel.rotation = vm.hasOwnProperty('type') ? vm.type : viewModel.rotation;
            
            setTimeout(function(){
                updatingFromCache = false;
            },10)
        }
    };

    function initialize(viewModel) {
        $('body').toggleClass(window.localStorage.expanded);
        
        if(window.localStorage.suspensionExpanded){
            $('.suspension-controls').toggleClass(window.localStorage.suspensionExpanded);
        }
        
        $('.visualizer-panel').each(function(i, vp) {
            setupVisualizerPanel(vp);
        });

        $('.visualizer-popout').each(function(i, vp) {
            setupVisualizerPanel(vp);
        });

        $('.vehicle-info-panel').each(function(i, vp) {
            setupVehicleInfoPanel(vp);
        });

        // anchor.attach('.visualizer-panel .inner');

        $(document.body)
            .on('click', '#visualizer-modal-close', function(e) {
                $('body').removeClass("open-visualizer-modal");
            })
            .on('click', '[data-visualize-wheel].open-modal', function(e) {
                $('body').addClass("open-visualizer-modal");
            })
            .on('click', '[data-visualize-wheel]', function(e) {
            var $button = $(e.target);
                var $product = $button.closest('.product');
                
                var wheelModelId = $button.data('visualizeWheel');
                var detailsUrl = $product.find('a.product-details').attr('href');
                var productId = $product.data('productid');

                loadWheel(wheelModelId, detailsUrl, productId);
                onPartSelection();

            })
            .on('click', '[data-vehicle-clear]', function(e){
                localStorage.removeItem("expanded");
            })
            .on('vehicle-activated', function(e) {
                 if (e.VehicleConfigurationID) loadVehicle(e.VehicleDescription, e.FitmentProfile, e.OverSizeTireRange);
                 else clearVehicle();
            })
            .on('product-configuration-selected', function(e){
                // takes the selected product SKU and returns the fitmentID to get thumbnail image
                ridestyler.ajax.send({
                  action: "Wheel/GetFitments",
                  data: {
                    partnumber: e.selectedCombination.ManufacturerPartNumber
                  },
                  callback: function (response) {
                    if (response.Fitments.length > 0) {
                        var wheelFitment = response.Fitments[0];

                        viewModel.wheel.selectedPartNumber = wheelFitment.WheelFitmentPartNumber;
                        viewModel.wheel.selectedFitmentID = wheelFitment.WheelFitmentID;
                        viewModel.wheel.selectedDiameter = wheelFitment.WheelFitmentDiameterMin;

                        checkWheelModelDescription(e.selectedCombination.ManufacturerPartNumber, wheelFitment.WheelFitmentID);
                    }
                  }
                });

                function checkWheelModelDescription(ManufacturerPartNumber, wheelfitment){
                    ridestyler.ajax.send({
                        action: "Wheel/GetModelDescriptions",
                        data: {
                          partnumbers: [ManufacturerPartNumber],
                          VehicleFitmentPosition: 1
                        },
                        callback: function (response) {
                            if (response.Models.length > 0) {
                                var model = response.Models[0];
                                viewModel.rotation = model.HasSideImage ? rotationOptions.side : rotationOptions.angle;
                                viewModel.thumbClickable = false;
                                viewModel.wheel.model = model;
                                if(viewModel.isWheelRenderable(model)) {
                                    viewModel.thumbClickable = true;
                                    refreshVehicleThumb({ wheelfitment: wheelfitment });
                                }
                            }
                        }
                    });
                }
            });

        window.addEventListener('storage', function (e) {
            if (Object.values(visualizerStorageKeys).indexOf(e.key) == -1) return;
            visualizer.updateViewModel(JSON.parse(e.newValue));
        });
    }

    function refreshVehicleThumb(options) {
        var selectedVehicle = viewModel.vehicle.model ? viewModel.vehicle.model.ConfigurationID : null;
        var selectedPaint = viewModel.vehicle.selectedScheme ? viewModel.vehicle.selectedScheme.Colors[0].Hex : '';
        var suspensionFront = viewModel.vehicle.suspension.front ? viewModel.vehicle.suspension.front : 0;
        var SuspensionRear = viewModel.vehicle.suspension.rear ? viewModel.vehicle.suspension.rear : 0;
        var rotation = viewModel.getBestRotation();
        
        var requestData = $.extend({
            vehicleconfiguration: selectedVehicle,
            positionx: 1,
            positiony: 1,
            type: rotation,
            width: 200,
            height: 75,
            paintColor: selectedPaint,
            SuspensionFront: suspensionFront,
            SuspensionRear: SuspensionRear
        }, options);

        viewModel.vehicle.thumbUrl = ridestyler.ajax.url('vehicle/render', requestData);
    }

    function setupVehicleInfoPanel(vp)
    {
        new Vue({ 
            el: vp, 
            data: viewModel,
            computed: {
                visualizationEnabled: function() {
                    return viewModel.vehicle.model != null && viewModel.vehicle.model.HasSideImage;
                }
        } });
    }

    function onPartSelection() {
        localStorage.setItem(visualizerStorageKeys.viewModel, JSON.stringify({
            wheel: viewModel.wheel,
            vehicle: viewModel.vehicle
        }));
    }

    function setupVisualizerPanel(vp) {
        var panelVue = new Vue({
            el: vp,
            data: viewModel,
            watch: {
                'vehicle.suspension.rear': function(e) { this.changeSuspension(e); },
                'vehicle.suspension.front': function(e) { this.changeSuspension(e); },
                'vehicle.suspension.locked': function(e) { this.changeSuspension(false); }
            },
            methods: {
                expandPanel: function () {
                    var expandClass = "visualizer-expand";
                    var expanded = window.localStorage.expanded === expandClass;

                    expanded = !expanded;
                    
                    window.localStorage.expanded = expanded ? expandClass : "";
                    $('body').toggleClass(expandClass, expanded );
                },
                toggleSuspensionPanel: function(){
                    var expandClass = "suspension-controls-expand";
                    var expanded = window.localStorage.suspensionExpanded === expandClass;

                    expanded = !expanded;

                    window.localStorage.suspensionExpanded = expanded ? expandClass : "";
                    $('.suspension-controls').toggleClass(expandClass, expanded );
                },
                changeDiameter: function(d) {
                    viewModel.wheel.selectedDiameter = d;
                    localStorage.setItem(visualizerStorageKeys.wheelDiameter, d);
                },
                changePaint: function(scheme) {
                    viewModel.vehicle.selectedScheme = scheme;
                    localStorage.setItem(visualizerStorageKeys.paintScheme, JSON.stringify({
                        VehicleConfigurationID: viewModel.vehicle.model.ConfigurationID,
                        Scheme: scheme
                    }));
                },
                changeSuspension: function(val){
                    if(!viewModel.vehicle.suspension || !viewModel.vehicle.model) return;
                    var locked = viewModel.vehicle.suspension.locked;
                    var rear = locked && val ? val : viewModel.vehicle.suspension.rear;
                    var front = locked && val ? val : viewModel.vehicle.suspension.front;
                    viewModel.vehicle.suspension.rear = rear;
                    viewModel.vehicle.suspension.front = front;
                    if(updatingFromCache) return;
                    localStorage.setItem(visualizerStorageKeys.suspension, JSON.stringify({
                        VehicleConfigurationID: viewModel.vehicle.model.ConfigurationID,
                        locked: locked,
                        rear: rear,
                        front: front,
                    }));
                },
                addToCart: function (wheel) {
                    window.addToCartDiameterOverride = viewModel.wheel.selectedDiameter;
                    products.addToCart({productId: wheel.productId});
                },
                showTireSizeFilter: function () {
                    tireSizeSelector.selectSize(function (size) {
                        if (size) {
                            window.location.href = '/tires?size=' + size;
                        }
                    });
                },
                changeRotation: function(val){
                    if(!viewModel.vehicleCanRotate()) return;
                    switch(viewModel.rotation){
                        case rotationOptions.side:
                            viewModel.rotation = rotationOptions.angle;
                            break;
                        case rotationOptions.angle:
                            viewModel.rotation = rotationOptions.side;
                            break;
                        default:
                            viewModel.rotation = rotationOptions.side;
                    }

                    localStorage.setItem(visualizerStorageKeys.rotation, JSON.stringify({
                        VehicleConfigurationID: viewModel.vehicle.model.ConfigurationID,
                        type: viewModel.rotation
                    }));
                }
            },
            computed: {
                visualizationEnabled: function() {
                    return viewModel.vehicle.model != null && viewModel.vehicle.model.HasSideImage;
                },
                currentWheelDetailsUrl: function () {
                    var wheel = viewModel.wheel;
                    
                    if (!wheel) return undefined;

                    var detailsUrl = wheel.detailsUrl;
                    var diameter = viewModel.wheel.selectedDiameter;
                    
                    if (detailsUrl.indexOf('?') == 0) return detailsUrl += "&diameter=" + diameter;
                    else return detailsUrl += "?diameter=" + diameter;
                }
            },
            components: {
                'visualizer-viewport':
                {
                    props: [ 'vehicle', 'wheel', 'rotation'],
                    watch: {
                        'vehicle.model': function() { this.refreshVisualizer(); },
                        'vehicle.selectedScheme': function() { this.refreshVisualizer(); },
                        'wheel.model': function() { this.refreshVisualizer(); },
                        'wheel.selectedDiameter': function() { this.refreshVisualizer(); },
                        'vehicle.suspension.rear': function() { this.refreshVisualizer(); },
                        'vehicle.suspension.front': function() { this.refreshVisualizer(); },
                        'rotation': function() { this.refreshVisualizer(); }
                    },
                    mounted: function() {
                        this.rsv = new RideStylerViewport(this.$el, {
                            responsive: true,
                            containerAspectRatio: 0.5
                        });
                        this.refreshVisualizer();
                    },
                    destroyed: function() {

                    },
                    template: '<div class="viewport-wrapper"></div>',
                    methods: {
                        refreshVisualizer: function() {
                            // Make sure we at least have a vehicle selected ...
                            if (this.vehicle.selected === false || this.vehicle.model === null) return;
                            // Get the image type based on what is supported by both the vehicle and wheel.
                            // Setup our render options
                            var renderOptions = {
                                PositionX: 1,
                                PositionY: 2,
                                SuspensionRear: this.vehicle.suspension.rear,
                                SuspensionFront: this.vehicle.suspension.front,
                                VehicleConfiguration: this.vehicle.model.ConfigurationID,
                                ExcludeDiscontinuedWheels: true,
                                Type: this.rotation
                            };
                            
                            if (this.wheel.selected) {
                                renderOptions.WheelFitment = this.wheel.fitmentLookup[this.wheel.selectedDiameter].WheelFitmentID;
                            }

                            if (this.vehicle.selectedScheme != null) {
                                renderOptions.PaintColor = this.vehicle.selectedScheme.Colors[0].Hex;
                            }

                            var self = this;
                            clearTimeout(self.refreshTimeout);
                            self.refreshTimeout = setTimeout(function() {
                                self.rsv.Update(renderOptions);
                            }, 1);
                        }
                    }
                }
            }
        });
    }

    function clearVehicle() {
        viewModel.vehicle.selectedScheme = null;
        viewModel.vehicle.tireOption = null;
        viewModel.vehicle.description = null;
        viewModel.vehicle.model = null;
        viewModel.vehicle.selected = false;
        viewModel.vehicle.suspension.rear = 0;
        viewModel.vehicle.suspension.front = 0;
        viewModel.rotation = rotationOptions.side;
        viewModel.ready = true;
    }

    function loadVehicle(vehicleModel, fitmentProfile, overSizeTireRange) {
        // Setup our variables to hold our models once they are loaded
        var tireOptionModel = fitmentProfile.TireOption;
        var vehicleConfigId = vehicleModel.ConfigurationID;

        // DEBUG: Uncomment to simulate a no-image vehicle
        //vehicleModel.HasSideImage = false;

        var cachedPaintScheme = viewModel.getCachedJsonItem(visualizerStorageKeys.paintScheme);
        var cachedWheel = viewModel.getCachedJsonItem(visualizerStorageKeys.wheel);
        var cachedWheelDiameter = viewModel.getCachedJsonItem(visualizerStorageKeys.wheelDiameter);
        var cachedSuspension = viewModel.getCachedJsonItem(visualizerStorageKeys.suspension);
        var cachedRotation = viewModel.getCachedJsonItem(visualizerStorageKeys.rotation);

        var thumbRequestData = { vehicleconfiguration: vehicleModel.ConfigurationID };

        if (cachedPaintScheme !== null) thumbRequestData.PaintColor = cachedPaintScheme.Scheme.Colors[0].Hex;
        if (cachedWheel !== null && cachedWheelDiameter !== null) {
            if(cachedWheel.FitmentLookup){
                thumbRequestData.WheelFitment = cachedWheel.FitmentLookup[cachedWheelDiameter].WheelFitmentID;
            }
        }
        if (cachedSuspension !== null) {
            thumbRequestData.SuspensionRear = cachedSuspension.rear;
            thumbRequestData.SuspensionFront = cachedSuspension.front;
        }
        if(cachedRotation) thumbRequestData.type = cachedRotation.type;

        refreshVehicleThumb(thumbRequestData);

        viewModel.vehicle.selectedScheme = null;
        viewModel.vehicle.fitmentProfile = fitmentProfile;
        viewModel.vehicle.tireOption = tireOptionModel;
        viewModel.vehicle.description = vehicleModel.Year + ' ' + vehicleModel.MakeName + ' ' + vehicleModel.ModelName;
        viewModel.vehicle.model = vehicleModel;
        viewModel.vehicle.selected = true;
        viewModel.ready = true;
        viewModel.vehicle.overSizeTireRange = overSizeTireRange;

        // Check for the existance of either the side or angled image. If none stop the process.
        if (!vehicleModel.HasSideImage && !vehicleModel.HasAngledImage) return;

        // Load our paintSchemes for this vehicle
        ridestyler.ajax.send({
            action: 'Vehicle/GetPaintSchemeDescriptions',
            data: {
                VehicleConfiguration: viewModel.vehicle.model.ConfigurationID
            },
            callback: function(r) {
                if (r.Success) {
                    for (var i = 0; i < r.Schemes.length; i++) {
                        viewModel.vehicle.paintSchemes.push(r.Schemes[i]);
                    }
                }
            }
        });

        // Load our suspension ranges for this vehicle
        ridestyler.ajax.send({
            action: 'Client/GetSettings',
            callback: function(r) {
                if (r.Success) {
                    var SuspensionRanges = r.Settings.ConfigSuspensionRanges;
                    var StyleType = viewModel.vehicle.model.StyleType;
                    var DriveType = viewModel.vehicle.model.DriveType;
                    var SuspensionRangeKey = StyleType + DriveType
                    var VehicleSuspensionRanges = SuspensionRanges[SuspensionRangeKey];
                    viewModel.vehicle.suspension.ranges.min = VehicleSuspensionRanges.Min;
                    viewModel.vehicle.suspension.ranges.max = VehicleSuspensionRanges.Max;
                }
            }
        });

        // Check to see if we can activate a cached suspension
        var cachedSuspension = viewModel.getCachedJsonItem(visualizerStorageKeys.suspension);
        if (cachedSuspension && cachedSuspension.VehicleConfigurationID == vehicleConfigId) {
            viewModel.vehicle.suspension.locked = cachedSuspension.locked;
            viewModel.vehicle.suspension.rear = cachedSuspension.rear;
            viewModel.vehicle.suspension.front = cachedSuspension.front;
        }

        // Check to see if we can activate a cached paint scheme
        var cachedScheme = viewModel.getCachedJsonItem(visualizerStorageKeys.paintScheme);
        if (cachedScheme && cachedScheme.VehicleConfigurationID == vehicleConfigId) {
            viewModel.vehicle.selectedScheme = cachedScheme.Scheme;
        }

        // Check to see if we can activate a cached rotation
        var cachedRotation = viewModel.getCachedJsonItem(visualizerStorageKeys.rotation);
        if (cachedRotation && cachedRotation.VehicleConfigurationID == vehicleConfigId) {
            viewModel.rotation = cachedRotation.type;
        } else {
            // Reset the rotation if the VehicleConfigurationID is not the same. 
            resetRotationCache();
            viewModel.rotation = getBestRotation();
        }

        // Ok, our vehicle has an image so we need to lookup wheel data for the visualizer.

        // Check to see if we have a last used wheel we can use
        wheelData = viewModel.getCachedJsonItem(visualizerStorageKeys.wheel);
        if (wheelData && wheelData.VehicleConfigurationID == vehicleConfigId) {
            setWheelData(wheelData.WheelModel, wheelData.FitmentLookup, wheelData.UniqueDiameters, localStorage.getItem(visualizerStorageKeys.wheelDiameter), wheelData.DetailsUrl, wheelData.wheelImage, wheelData.boltPattern, wheelData.productId);
        }

        // First, find all of our visualize buttons on the page
        var $buttons = $('[data-visualize-wheel]');

        // Second, let's create a cache of all the wheel model IDs on the page
        pageWheelModels = {};
        $buttons.each(function(i, ele) {
            pageWheelModels[$(ele).data('visualizeWheel')] = false;
        });

        // Third, let's request the model data from the API for all of these at once. This will let us know
        // if they have the image we need. We can also use this data later so it isn't a waste.
        ridestyler.ajax.send({
            action: 'Wheel/GetModelDescriptions',
            data: {
                VehicleConfiguration: vehicleConfigId,
                WheelModels: Object.keys(pageWheelModels),
                DisableInventoryFiltering: true,
                IncludeFitments: true, // Yup, we need these.
                VehicleFitmentPosition: 1
            },
            callback: function(r) {
                if (r.Success && r.Models.length > 0) {
                    // Update our model cache with the data objects from our API request
                    for(var i = 0; i < r.Models.length; i++) {
                        var m = r.Models[i];

                        pageWheelModels[m.WheelModelID] = m;
                    }

                    $buttons.each(function(i, ele) {
                        var m = pageWheelModels[$(ele).data('visualizeWheel')];
                        if (viewModel.isWheelRenderable(m)) {
                            ele.style.display = "block";
                        }
                    });
                }
            }
        });
    }

    function loadWheel(wheelModelId, detailsUrl, productId) {
        // Do not allow us to select a wheel if there is no active vehicle ... Pointless.
        if (viewModel.vehicle.selected === false) return;
        var m = pageWheelModels[wheelModelId];

        productId = productId || viewModel.wheel.productId;

        // Create a unique list of diameters sorted
        var fitmentLookup = {};
        for(var i = 0; i < m.WheelFitments.length; i++) {
            var f = m.WheelFitments[i];
            fitmentLookup[f.DiameterMin] = f;
        }
        uniqueDiameters = Object.keys(fitmentLookup).sort(function(a, b) {
            if (a < b) return -1;
            else if (a > b) return 1;
            return 0;
        });

        var currentDiameter = viewModel.wheel.selectedDiameter;
        if (!currentDiameter) {
            var to = viewModel.vehicle.tireOption;
            currentDiameter = (to.Front.InsideDiameter + to.Rear.InsideDiameter) / 2;
        }

        var distance = 1000;
        var bestDiameter = 0;

        for(var i = 0; i < uniqueDiameters.length; i++) {
            var d = Math.abs(uniqueDiameters[i] - currentDiameter);
            if (d < distance) {
                distance = d;
                bestDiameter = uniqueDiameters[i];
            }
        }

        var wheelImage = ridestyler.ajax.url('Wheel/Image', {
          "WheelModel": wheelModelId,
          "Width": 175,
          "Height": 175,
          "WheelFitmentResourceType": "Catalog"
        });

        if (fitmentLookup[currentDiameter]) {
            var boltPattern = fitmentLookup[currentDiameter].BoltPatternDescription;
        }

        localStorage.setItem(visualizerStorageKeys.wheel, JSON.stringify({
            VehicleConfigurationID: viewModel.vehicle.model.ConfigurationID,
            WheelModel: m,
            selectedPartNumber: viewModel.wheel.selectedPartNumber,
            FitmentLookup: fitmentLookup,
            UniqueDiameters: uniqueDiameters,
            DetailsUrl: detailsUrl,
            wheelImage: wheelImage,
            boltPattern: boltPattern,
            productId: productId
        }));

        localStorage.setItem(visualizerStorageKeys.wheelDiameter, bestDiameter);

        // Update our view models with information for this wheel
        setWheelData(m, fitmentLookup, uniqueDiameters, bestDiameter, detailsUrl, wheelImage, boltPattern, productId);

        // Update the best rotation for this wheel
        viewModel.rotation = viewModel.getBestRotation();

        localStorage.setItem(visualizerStorageKeys.rotation, JSON.stringify({
            VehicleConfigurationID: viewModel.vehicle.model.ConfigurationID,
            type: viewModel.rotation
        }));

    }

    function setWheelData(m, fitmentLookup, uniqueDiameters, bestDiameter, detailsUrl, wheelImage, boltPattern, productId) {
        viewModel.wheel.productId = productId;
        viewModel.wheel.detailsUrl = (detailsUrl && detailsUrl.length > 0) ? detailsUrl : null;
        viewModel.wheel.description = m.WheelBrandName + ' - ' + m.WheelModelName;
        viewModel.wheel.model = m;
        viewModel.wheel.fitmentLookup = fitmentLookup;
        viewModel.wheel.diameters = uniqueDiameters;
        viewModel.wheel.selectedDiameter = bestDiameter;
        viewModel.wheel.selected = true;
        viewModel.wheel.wheelImage = wheelImage;
        viewModel.wheel.boltPattern = boltPattern;
    }

    function expandPopupModal(elementIsClicked) {
        var paintColor = viewModel.vehicle.selectedScheme ? viewModel.vehicle.selectedScheme.Colors[0].Hex :  '';
        var currentVehicle = viewModel.vehicle.model.ConfigurationID;
        var fitment = localStorage.getItem(visualizerStorageKeys.wheelDiameter);
        var currentWheel = !viewModel.wheel.fitmentLookup ? '' : viewModel.wheel.fitmentLookup[fitment].WheelFitmentID;
        var cachedWheel = JSON.parse(localStorage.getItem(visualizerStorageKeys.cachedWheel));
        var suspension = viewModel.suspension ? viewModel.suspension : {rear: 0, front: 0};
        var rotation = viewModel.getBestRotation();

        var selectedWheel = elementIsClicked ? 
            viewModel.wheel.selectedFitmentID || currentWheel :
            currentWheel;
        
        $vehicleVisualizationModal.show(currentVehicle, selectedWheel, paintColor, suspension, rotation);
    }

    function thumbnailHandler() {
        var elementIsClicked = true; 
        expandPopupModal(elementIsClicked);
    }

    function openInExternalWindow(){
        if (childWindow && !childWindow.closed) {
            childWindow.focus();
        } else {
            childWindow = window.open(window.origin + '/RideStyler/VehiclePopout', '_blank', "height=650,width=1300,scrollbars=no");
        }
    }

    function resetVehicleCache() {
        localStorage.setItem(visualizerStorageKeys.vehicle, JSON.stringify({
            ConfigurationID: null,
            selectedScheme: null,
            tireOption: null,
            description: null,
            model: null,
            selected: false,
            ready: true
        }))
    }

    function resetRotationCache() {
        localStorage.setItem(visualizerStorageKeys.rotation, JSON.stringify({
            VehicleConfigurationID: null,
            type: rotationOptions.side
        }));
    }

    function getBestRotation(options) {
        //Check if wheels are capable of the views
        if(viewModel.wheel.model && !viewModel.wheel.model.HasSideImage) return rotationOptions.angle;
        if(viewModel.wheel.model && !viewModel.wheel.model.HasAngleImage) return rotationOptions.side;

        //Check for a cached rotation
        var cachedRotation = getCachedJsonItem(visualizerStorageKeys.rotation);

        //Return the default
        return cachedRotation ? cachedRotation.type : rotationOptions.side;
    }

    function getCachedJsonItem(cacheName){
        var cache = localStorage.getItem(cacheName);
        if (!cache) return null;
        var cachedItem = JSON.parse(cache);
        return cachedItem ? cachedItem : null;
    }

    function vehicleCanRotate() {
        if(!viewModel.wheel.model) return false;
        if(!viewModel.vehicle.model) return false;
        if(!(viewModel.wheel.model.HasAngleImage && viewModel.wheel.model.HasSideImage)) return false;
        if(!(viewModel.vehicle.model.HasAngledImage && viewModel.vehicle.model.HasSideImage)) return false;
        return true;
    }

    function isWheelRenderable(wheelModel) {
        if ((wheelModel.HasSideImage && viewModel.vehicle.model.HasSideImage) || (wheelModel.HasAngleImage && viewModel.vehicle.model.HasAngledImage)) return true;
        return false;
    }
}();